import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// Initialize i18n before rendering
import './i18n'
import App from './App.tsx'

// Render immediately — no SDKs block the first paint
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Defer heavy observability SDKs until after first paint
const loadObservability = async () => {
  // Sentry
  const { initSentryLazy } = await import('./lib/lazySentry')
  await initSentryLazy()

  // PostHog
  const posthogKey = (import.meta.env.VITE_POSTHOG_KEY ?? '').trim()
  if (posthogKey) {
    const { default: posthog } = await import('posthog-js')
    posthog.init(posthogKey, {
      api_host: (import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com').trim(),
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
    })
  }

  // Crisp chat widget
  const { initCrispLazy } = await import('./lib/crisp')
  await initCrispLazy()
}

if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(() => { loadObservability() })
} else {
  setTimeout(() => { loadObservability() }, 1)
}
